import React from 'react'
const SJNoData = () => <div className="col-md-12 flex-center">No Data Available</div>
export default SJNoData